import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion3 from '../../../../ui/images/questions/ela/grade-k1/question-3.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k1/question-5.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k1_1',
    title: 'Which word sounds like “hat”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k1_1_a',
        text: 'hit',
      },
      {
        name: 'grade_k1_1_b',
        text: 'mat',
        correct: true,
      },
      {
        name: 'grade_k1_1_c',
        text: 'hot',
      },
    ],
  },
  {
    name: 'grade_k1_2',
    title: 'Which word rhymes with “cat”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k1_2_a',
        text: 'cap',
      },
      {
        name: 'grade_k1_2_b',
        text: 'cut',
      },
      {
        name: 'grade_k1_2_c',
        text: 'rat',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_3',
    title: 'Which word rhymes with “dog”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k1_3_a',
        text: 'dig',
      },
      {
        name: 'grade_k1_3_b',
        text: 'log',
        correct: true,
      },
      {
        name: 'grade_k1_3_c',
        text: 'big',
      },
    ],
  },
  {
    name: 'grade_k1_4',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The moon is bright tonight. The owls are waking up, but the farm dogs are going to sleep in their houses.”',
    sentence: 'When does this story take place?',
    answers: [
      {
        name: 'grade_k1_4_a',
        text: 'In the morning',
      },
      {
        name: 'grade_k1_4_b',
        text: 'In the afternoon',
      },
      {
        name: 'grade_k1_4_c',
        text: 'At night',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '”The bright yellow sun is shining high in the blue sky today.”',
    sentence: 'How does the weather feel?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k1_5_a',
        text: 'Cold and windy',
      },
      {
        name: 'grade_k1_5_b',
        text: 'Sunny and warm',
        correct: true,
      },
      {
        name: 'grade_k1_5_c',
        text: 'Wet and rainy',
      },
    ],
  },
  {
    name: 'grade_k1_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '”Lily is a vet. She helps sick animals feel better. Today, she is helping a dog with a hurt paw.”',
    sentence: 'What is Lily\'s job?',
    answers: [
      {
        name: 'grade_k1_6_a',
        text: 'She is a teacher',
      },
      {
        name: 'grade_k1_6_b',
        text: 'She is a farmer',
      },
      {
        name: 'grade_k1_6_c',
        text: 'She is an animal doctor',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_7',
    title: 'What is the best word to start this sentence?',
    topic: AssessmentTopics.Writing,
    condition: '_____ is your name?',
    answers: [
      {
        name: 'grade_k1_7_a',
        text: 'Who',
      },
      {
        name: 'grade_k1_7_b',
        text: 'What',
        correct: true,
      },
      {
        name: 'grade_k1_7_c',
        text: 'How',
      },
    ],
  },
  {
    name: 'grade_k1_8',
    title: 'Which punctuation mark is missing at the end of this sentence?',
    topic: AssessmentTopics.Writing,
    condition: 'Can you help me find my backpack',
    answers: [
      {
        name: 'grade_k1_8_a',
        text: 'period (.)',
      },
      {
        name: 'grade_k1_8_b',
        text: 'question mark (?)',
        correct: true,
      },
      {
        name: 'grade_k1_8_c',
        text: 'exclamation point (!)',
      },
    ],
  },
  {
    name: 'grade_k1_9',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k1_9_a',
        text: 'the sun is shining bright.',
      },
      {
        name: 'grade_k1_9_b',
        text: 'The sun is shining bright',
      },
      {
        name: 'grade_k1_9_c',
        text: 'The sun is shining brightly.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_10',
    title: 'Which word is a noun?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k1_10_a',
        text: 'run',
      },
      {
        name: 'grade_k1_10_b',
        text: 'cat',
        correct: true,
      },
      {
        name: 'grade_k1_10_c',
        text: 'happy',
      },
    ],
  },
  {
    name: 'grade_k1_11',
    title: 'Which sentence uses capital letters correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k1_11_a',
        text: 'my mom is nice',
      },
      {
        name: 'grade_k1_11_b',
        text: 'My mom is nice',
        correct: true,
      },
      {
        name: 'grade_k1_11_c',
        text: 'My Mom Is Nice',
      },
    ],
  },
  {
    name: 'grade_k1_12',
    title: 'Which word is the verb in this sentence?',
    topic: AssessmentTopics.Language,
    sentence: 'The bird sings a song.',
    answers: [
      {
        name: 'grade_k1_12_a',
        text: 'bird',
      },
      {
        name: 'grade_k1_12_b',
        text: 'sings',
        correct: true,
      },
      {
        name: 'grade_k1_12_c',
        text: 'song',
      },
    ],
  },
]
